import { ChannelType } from 'components/CampaignCreationModal/Types'
import { CalendarFilters } from '../types'
import { DesignChannel } from 'components/NewFileModal/Types'
import { AlmanacFileShowItem } from 'hooks/queries/files/types'
import { AlmanacFileCalendarItem } from 'hooks/queries/calendar/types'
import { Icon } from 'blaze-ui/icons/Types'
import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'
import { PostPreviewChannelType } from 'components/PostPreviewModal/Types'
import { ExternalIntegration, ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'

export type AlmanacFileUnion = AlmanacFileShowItem | AlmanacFileCalendarItem

export interface FullScreenPreviewProps {
  id: string
  startDate: string | null
  filters: CalendarFilters
  onClose: () => void
  channel?: ChannelType | DesignChannel | GenerationType | null
  width?: number | null
  height?: number | null
  assetType?: string
  loadingStateColor?: string
  showCarousel?: boolean
  updateCurrentItem?: boolean
  entryPoint?: string
  useChat?: boolean
}

export interface PostPreviewProps {
  almanacFile?: AlmanacFileUnion
  isLoading: boolean
  showVideoControls?: boolean
  videoFit?: 'contain' | 'cover'
  isActive?: boolean
  channelOverride?: PostPreviewChannelType
  integrationOverride?: ExternalIntegration | null
  setIsLoading?: (isLoading: boolean) => void
  onClose?: () => void
  onDelete?: () => void
  filters?: CalendarFilters
  fileChannel?: ChannelType | DesignChannel | GenerationType | null
  startDate?: string
  previewPlatform?: ExternalIntegrationEnum
  onSelectPlatform?: (platform: ExternalIntegrationEnum) => void
  isInsertingMedia?: boolean
  isTransitioning?: boolean
  showHoverActionOverlay?: boolean
  hideConnectButton?: boolean
  alwaysTruncateCaption?: boolean
  onSeeMoreToggle?: (expanded: boolean) => void
  seeMore?: boolean
  hasRatingOverlay?: boolean
  windowHeightOffset?: number
}

export interface NavigationButtonProps {
  icon: Icon
  onPress: () => void
  side: 'left' | 'right'
  isDisabled?: boolean
  chatOpen?: boolean
}

export interface PostActionsButtonProps {
  almanacFile?: AlmanacFileUnion
  isDisabled?: boolean
  onDelete: () => void
}

export interface HeaderProps {
  id: string
  startDate: string | null
  almanacFile?: AlmanacFileUnion
  isIntersecting: boolean
  onClose: () => void
  filters: CalendarFilters
  isLoading: boolean
  onDelete: () => void
  setIsLoading: (isLoading: boolean) => void
  channel?: ChannelType | DesignChannel | GenerationType
  chatOpen?: boolean
  entryPoint?: string
}

export const TYPES_WITH_PREVIEW = [
  DesignChannel.LinkedInPost,
  ChannelType.LinkedInPosts,
  DesignChannel.InstagramPost,
  ChannelType.InstagramPosts,
  DesignChannel.InstagramReel,
  DesignChannel.InstagramStory,
  DesignChannel.FacebookStory,
  DesignChannel.TwitterPost,
  ChannelType.Tweets,
  DesignChannel.FacebookPost,
  ChannelType.FacebookPost,
  DesignChannel.TikTokPost,
  DesignChannel.YoutubeShort,
  DesignChannel.GoogleMyBusinessPost,
]

export const TYPES_WITH_CAPTION_ABOVE_IMAGE = [
  DesignChannel.LinkedInPost,
  ChannelType.LinkedInPosts,
  DesignChannel.TwitterPost,
  ChannelType.Tweets,
  DesignChannel.FacebookPost,
  ChannelType.FacebookPost,
]

export const TYPES_WITH_CAPTION_BELOW_IMAGE = [DesignChannel.InstagramPost, ChannelType.InstagramPosts]
